export default "__VITE_ASSET__CsFgZyUZ__"